import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';
import ErrorText from './ErrorText';

const CheckboxInput = ({ name, label, onChange, value, checked, disabled, touched, error, classes }) => {
  const uniqueIdentifier = `${value}-${name}`;
  const classList = `checkbox-input ${classes}`;

  return (
    <div className={classList}>
      <input
        type="checkbox"
        id={uniqueIdentifier}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      <label htmlFor={uniqueIdentifier}>{renderHTML(label)}</label>
      {touched && error && <ErrorText>{error}</ErrorText>}
    </div>
  );
};

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  touched: PropTypes.bool,
  classes: PropTypes.string,
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/CheckboxInput.js